<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_chat')
}

const isOnChatSection = computed(() => {
  return route.path.startsWith('/communication')
})

const goToChat = () => {
  router.push('/communication')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.communication.intro.needCommunicate') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.communication.intro.headOver') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.communication.intro.clickCommunicationDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.communication.intro.clickCommunicationMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnChatSection" @click="goToChat" class="mr-2">
        {{ t('tutorial.communication.intro.goToChat') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.communication.intro.imThere') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>